import type { SupplierAction } from './actions';
import * as types from './types';
import type { SupplierState } from './types';

const initialState: SupplierState = {
  activeTeamMember: {},
  isActiveTeamMemberEmailVerified: null,
  isEmailResendFetching: false,
  isCreatingTeamMember: false,
  teamMembers: [],
};

export default function supplier(
  state: SupplierState = initialState,
  action: SupplierAction,
): SupplierState {
  switch (action.type) {
    case types.GET_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        activeTeamMember: action.payload.teamMember,
      };

    case types.GET_TEAM_MEMBER_ERROR:
    case types.CREATE_TEAM_MEMBER:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: false,
        activeTeamMember: {},
      };

    case types.GET_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        teamMembers: action.payload.teamMembers,
      };

    case types.GET_TEAM_MEMBERS_ERROR:
      return {
        ...state,
        teamMembers: [],
      };

    case types.UPDATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        activeTeamMember: action.payload.teamMember,
      };
    case types.DELETE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        teamMembers: (state.teamMembers || []).filter(
          (member) => member.id !== action.payload.teamMemberId,
        ),
      };
    case types.SEND_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        isEmailResendFetching: true,
      };
    case types.SEND_VERIFICATION_EMAIL_SUCCESS:
    case types.SEND_VERIFICATION_EMAIL_ERROR:
      return {
        ...state,
        isEmailResendFetching: false,
      };
    case types.CHECK_EMAIL_VERIFICATION_REQUEST:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: null,
      };
    case types.CHECK_EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: action.payload.isVerified,
      };
    case types.CHECK_EMAIL_VERIFICATION_ERROR:
      return {
        ...state,
        isActiveTeamMemberEmailVerified: false,
      };
    case types.CREATE_TEAM_MEMBER_REQUEST:
      return {
        ...state,
        isCreatingTeamMember: true,
      };
    case types.CREATE_TEAM_MEMBER_SUCCESS:
    case types.CREATE_TEAM_MEMBER_ERROR:
      return {
        ...state,
        isCreatingTeamMember: false,
      };
    default:
      return state;
  }
}
